// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M4 2H12C13.1 2 14 2.9 14 4V9.8C14 10.9 13.1 11.8 12 11.8H6.25C5.83 11.8 5.42 11.95 5.1 12.22L2.65 14.15C2.37 14.37 2 14.17 2 13.82V4C2 2.9 2.9 2 4 2Z',
  'M4.8 5.4C7.05 4.27 8.95 6.53 11.2 5.4',
  'M4.8 8.4C7.05 7.27 8.95 9.53 11.2 8.4',
];
